import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";

class DocumentSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("DocumentLabel");
    }

    public getItemIconClass(): string {
        return "documentsIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(): null {
        return null;
    }

    public getPinFrequencyToken(loginPinFrequencyModel: LoginPinFrequencyModel): string {
        return loginPinFrequencyModel?.documentToken ?? "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { DocumentSharedItemProvider };
